module.exports = __webpack_public_path__ + "media/newstyle/images/Google_Play-a2d4ae5aee746d5711876180628d7851.svg";